module.exports = __webpack_public_path__ + "img/library-blog.abc8f108.png";